import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["property_value_paths"];
import { convertJsonToJacksonFieldValueAvro } from './chirp';
const mapObject = (object = {}, fn) => {
  const result = {};
  for (const [key, value] of Object.entries(object)) {
    result[key] = fn(value);
  }
  return result;
};
export const convertOverridesToJackson = (record = {}) => {
  const result = {};
  for (const [key, value] of Object.entries(record)) {
    result[key] = convertJsonToJacksonFieldValueAvro(value);
  }
  return result;
};
export const convertBindingsToJackson = (bindings = {}) => {
  return mapObject(bindings, variantBindings => {
    return mapObject(variantBindings, variantBinding => {
      return mapObject(variantBinding, bindingConfig => {
        const _ref = bindingConfig || {},
          {
            property_value_paths: propertyValuePaths
          } = _ref,
          rest = _objectWithoutPropertiesLoose(_ref, _excluded);
        return {
          bindingConfig: Object.assign({
            propertyValuePaths
          }, rest)
        };
      });
    });
  });
};
export const convertVariantDataToJackson = (variantData = {}) => {
  const result = {};
  for (const [key, value] of Object.entries(variantData)) {
    result[key] = convertOverridesToJackson(value);
  }
  return result;
};
export const prependGoogleFontUrls = (fontStyles, previewDomain) => {
  return fontStyles.map(fontStyle => {
    return fontStyle.replaceAll('"/_hcms/googlefonts', `"//${previewDomain}/_hcms/googlefonts`);
  });
};